(function () {
  if (window.__variantLowStockBadgeLoaded) return;
  window.__variantLowStockBadgeLoaded = true;

  var badgeSelector = '.marketdive-lowstock-variant-badge';
  var cardSelector = '.variant-visual-card, .variant-card, .swatch-input__label--hybrid-card';
  var statusSelector = '.variant-visual-card__status, .variant-card__status, .variant-hybrid-card__status';
  var inCardClass = 'marketdive-lowstock-variant-badge--in-card';
  var duplicateClass = 'marketdive-lowstock-variant-badge--duplicate';
  var ignoredClass = 'marketdive-lowstock-variant-badge--ignored';
  var statusClass = 'variant-low-stock-status';
  var defaultStatusAttribute = 'data-low-stock-default';
  var syncQueued = false;

  function toArray(items) {
    return Array.prototype.slice.call(items || []);
  }

  function getRoots() {
    var roots = toArray(document.querySelectorAll('product-info'));
    return roots.length ? roots : [document];
  }

  function findLabelForInput(input, root) {
    if (!input || !input.id) return null;
    var labels = toArray((root || document).querySelectorAll('label'));

    return labels.find(function (label) {
      return label.htmlFor === input.id && label.querySelector(statusSelector);
    });
  }

  function cardFromElement(element, root) {
    if (!element || !element.matches) return null;

    if (element.matches(cardSelector)) return element;
    if (element.matches('label') && element.querySelector(statusSelector)) return element;
    if (element.matches('input[type="radio"]')) return findLabelForInput(element, root);

    return null;
  }

  function findCardForBadge(badge) {
    var card = badge.closest(cardSelector);
    if (card) return card;

    var root = badge.closest('.product-form__input') || badge.closest('variant-selects') || document;
    var sibling = badge.previousElementSibling;

    while (sibling) {
      card = cardFromElement(sibling, root);
      if (card) return card;
      sibling = sibling.previousElementSibling;
    }

    sibling = badge.nextElementSibling;

    while (sibling) {
      card = cardFromElement(sibling, root);
      if (card) return card;
      sibling = sibling.nextElementSibling;
    }

    return null;
  }

  function getInputForCard(card) {
    if (!card) return null;

    var inputId = card.getAttribute('for');
    if (inputId) return document.getElementById(inputId);

    var sibling = card.previousElementSibling;
    if (sibling && sibling.matches && sibling.matches('input[type="radio"]')) return sibling;

    return null;
  }

  function isUnavailable(input) {
    return (
      input &&
      (input.disabled ||
        input.classList.contains('disabled') ||
        input.classList.contains('variant-option-unavailable'))
    );
  }

  function hideBadge(badge, className) {
    badge.classList.remove(inCardClass);
    badge.classList.add(className);
    badge.hidden = true;
  }

  function showBadge(badge) {
    badge.hidden = false;
    badge.classList.remove(duplicateClass, ignoredClass);
    badge.classList.add(inCardClass);
  }

  function resetStatus(status) {
    if (status.querySelector(badgeSelector + '.' + inCardClass)) return;

    if (status.hasAttribute(defaultStatusAttribute)) {
      status.textContent = status.getAttribute(defaultStatusAttribute);
      status.removeAttribute(defaultStatusAttribute);
    }

    status.classList.remove(statusClass);
  }

  function clearStatus(status, badge) {
    toArray(status.childNodes).forEach(function (node) {
      if (node !== badge) node.remove();
    });
  }

  function placeBadge(badge) {
    if (!badge.isConnected) return;

    var card = findCardForBadge(badge);
    if (!card) return;

    var status = card.querySelector(statusSelector);
    if (!status) return;

    if (isUnavailable(getInputForCard(card))) {
      hideBadge(badge, ignoredClass);
      resetStatus(status);
      return;
    }

    var existing = status.querySelector(badgeSelector + '.' + inCardClass);
    if (existing && existing !== badge) {
      hideBadge(badge, duplicateClass);
      return;
    }

    if (
      badge.parentElement === status &&
      badge.classList.contains(inCardClass) &&
      status.childNodes.length === 1
    ) {
      status.classList.add(statusClass);
      return;
    }

    if (!status.hasAttribute(defaultStatusAttribute)) {
      status.setAttribute(defaultStatusAttribute, status.textContent.trim());
    }

    clearStatus(status, badge);
    showBadge(badge);
    status.appendChild(badge);
    status.classList.add(statusClass);
  }

  function syncRoot(root) {
    toArray(root.querySelectorAll('.' + statusClass)).forEach(resetStatus);
    toArray(root.querySelectorAll(badgeSelector)).forEach(placeBadge);
  }

  function sync() {
    syncQueued = false;
    getRoots().forEach(syncRoot);
  }

  function queueSync() {
    if (syncQueued) return;
    syncQueued = true;
    window.requestAnimationFrame(sync);
  }

  function init() {
    queueSync();

    document.addEventListener('change', function (event) {
      if (event.target && event.target.matches('input[type="radio"]')) queueSync();
    });

    document.addEventListener('shopify:section:load', queueSync);

    if (document.body) {
      new MutationObserver(queueSync).observe(document.body, {
        attributes: true,
        attributeFilter: ['class', 'disabled', 'hidden', 'style'],
        childList: true,
        subtree: true,
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
